function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import axios from 'axios';
import { getSMDeviceId } from './util.fp';
import Env from './util.env.js';
import Didasdk from './util.didasdk.js';
import tc3 from './config/tc3';
import { getQueryString } from './util.url.js';
import crypto from 'crypto-js';
var service = axios.create({
  timeout: 8000 // 请求超时时间

});
var mobile = Env.isAndroid ? '2' : '1';
var ddcinfo = {
  latitude: '39.915526',
  longitude: '116.403847',
  location_time: '20190730152608',
  mobiletype: mobile,
  identifier: Env.isDidaTaxi ? 'weixin.h5.driver' : 'weixin.h5',
  version: (Env.curAppVersion || '8.9.5') + '.app_h5',
  net: 'unknown',
  os: 'web',
  deviceId: ''
}; // 此处需要隐藏

var DES_KEY = 'bShORr6y6EQ='; // ddcinfo增加转码加密

function encryptByDESModeCBC(message, key) {
  var keyHex = crypto.enc.Utf8.parse(key);
  var ivHex = crypto.enc.Utf8.parse(key);
  var encrypted = crypto.DES.encrypt(message, keyHex, {
    iv: ivHex,
    mode: crypto.mode.CBC,
    padding: crypto.pad.Pkcs7
  });
  return crypto.enc.Base64.stringify(encrypted.ciphertext);
}

function btoa_encode(ddcinfo) {
  return encryptByDESModeCBC(JSON.stringify(ddcinfo), DES_KEY);
}

function get_cookie(name) {
  var arr,
      reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
}

try {
  getSMDeviceId().then(function (deviceId) {
    if (deviceId) {
      ddcinfo.deviceId = deviceId;
    }
  });

  if (Env.inApplication) {
    Didasdk.ready(function () {
      // 获取网络状态
      Didasdk.callHandler('getNetworkStatus', null).then(function (res) {
        try {
          console.info('[Didasdk] getNetworkStatus res => ' + "(".concat(res, ")"));
          ddcinfo.net = JSON.parse(res).net_type;
        } catch (e) {
          console.error('[Didasdk] getNetworkStatus 1 => \n', e);
        }
      });
    });
  }
} catch (e) {
  console.error('[Didasdk] getSMDeviceId 2 => \n', e);
} // 请求拦截器


service.interceptors.request.use(function (config) {
  if (config) {
    var __ddcinfo = Object.assign({}, ddcinfo);

    if (config.ddcinfo) {
      Object.assign(__ddcinfo, config.ddcinfo);
      __ddcinfo.latitude = String(__ddcinfo.latitude);
      __ddcinfo.longitude = String(__ddcinfo.longitude);
    } // 获取url中或请求头中access_token或cookie中的token


    console.log('cookie', get_cookie('access_token'));
    var access_token = getQueryString('access_token') || config.headers['x-access-token'] || get_cookie('access_token') || localStorage.getItem('access_token') || sessionStorage.getItem('access_token') || '';
    config.headers['ddcinfo'] = btoa_encode(__ddcinfo); // 目的：参数增加cid。非空处理。

    var params = config.params || config.data && (typeof config.data === 'string' ? config.data.split('&').reduce(function (prev, val) {
      var keyVal = val.split('=');
      prev[keyVal[0]] = keyVal[1];
      return prev;
    }, {}) : config.data) || {};
    var user_cid = params.cid || params.usercid || params.userCid || params.user_cid || getQueryString('cid') || getQueryString('usercid') || getQueryString('userCid') || getQueryString('user_cid') || get_cookie('cid') || localStorage.getItem('cid') || sessionStorage.getItem('cid') || ''; // 增加cid get请求

    if (config.params) {
      config.params.user_cid = user_cid;
    } // console.log('config', config);
    // post请求增加cid


    if (config.data && user_cid) {
      if (typeof config.data === 'string') {
        config.data.indexOf('user_cid') === -1 && (config.data += '&user_cid=' + user_cid);
      } else {
        config.data.user_cid = user_cid;
      }
    }

    var auth = {};

    if (config.url.includes('/web')) {
      // auth = { ...tc3(config.method, '/web' + config.url.split('/web')[1].split('?')[0], config.params || config.data, config.headers) };
      // 注释原因===>>>>接口会出现多个/web
      auth = _objectSpread({}, tc3(config.method, config.url.slice(config.url.indexOf('/web')).split('?')[0], config.params || config.data, config.headers));
    }

    console.log("===请求头配置===", config);
    config.headers.ddcinfo = btoa_encode(__ddcinfo);
    config.headers = _objectSpread(_objectSpread({}, config.headers), {}, {
      ddcinfo: btoa_encode(__ddcinfo),
      // test

      /**
       * 旧项目验签兼容处理。
       * 原因：只更改84-86行代码只是新的验签key值不存在。但是user_cid和token还是会对旧的验签有影响。
       *
       * */
      user_cid: user_cid,
      cid: user_cid,
      'x-access-token': access_token
    }, auth);
  }

  return config;
}, function (error) {
  // 发送失败
  console.error(error);
  return Promise.reject(error);
});
service.interceptors.response.use(function (config) {
  return config;
}, function (error) {
  // 统一处理cid和token没有的失败情况
  var res = error;

  if (error.response) {
    res = error.response.data;
  }

  return Promise.reject(res);
});
export default service;